(function () {
  if (window.trHomeLoaded) return;
  window.trHomeLoaded = true;

  // Category accordion: hover (desktop) or first tap opens a card; a click on the open card follows its link
  function openCard(card) {
    Array.prototype.forEach.call(card.parentNode.children, function (el) {
      el.classList.toggle('is-active', el === card);
    });
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-trh-accordion] > .trh-cat');
    if (!card || card.classList.contains('is-active')) return;
    event.preventDefault();
    openCard(card);
  });

  document.addEventListener('mouseover', function (event) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var card = event.target.closest('[data-trh-accordion] > .trh-cat');
    if (card && !card.classList.contains('is-active')) openCard(card);
  });

  if (!('IntersectionObserver' in window)) return;

  // Lets iOS Safari apply :active styles on touch (product card highlight)
  document.addEventListener('touchstart', function () {}, { passive: true });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Counter: same behaviour as sections/company-stats.liquid (ease-out count, suffix shown at the end)
  function runCounters(stats) {
    var duration = parseInt(stats.getAttribute('data-trh-duration'), 10) || 2000;
    stats.querySelectorAll('[data-trh-count]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-trh-count'), 10);
      var suffix = el.parentNode.querySelector('.trh-stat__suffix');
      var start = performance.now();
      function step(now) {
        var p = Math.min((now - start) / duration, 1);
        el.textContent = Math.floor(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = end;
          if (suffix) suffix.classList.remove('is-hidden');
        }
      }
      if (suffix) suffix.classList.add('is-hidden');
      el.textContent = '0';
      requestAnimationFrame(step);
    });
  }

  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      counterObserver.unobserve(entry.target);
      runCounters(entry.target);
    });
  }, { threshold: 0.2 });

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.15 });

  function init(root) {
    root.querySelectorAll('[data-trh-counter]').forEach(function (el) {
      counterObserver.observe(el);
    });

    if (reduceMotion) return;
    root.querySelectorAll('.trh').forEach(function (section) {
      section.classList.add('trh-anim');
      section.querySelectorAll('[data-trh-reveal]:not(.is-in)').forEach(function (el) {
        revealObserver.observe(el);
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
